import React, { useEffect, useState } from 'react';
import Image from 'next/image';

import styles from './styles.module.scss';

const ProductBadges = ({ badges, className = '', stickersIds, stickers }) => {
  const [badgeList, setBadgeList] = useState([]);

  useEffect(() => {
    const stickersList = stickers?.filter((el) => stickersIds?.includes(el.id)).sort((a, b) => a.position - b.position);

    setBadgeList([...stickersList]);
  }, [badges, stickers, stickersIds]);

  return (
    <>
      {badgeList.map((badgeType) =>
        badgeType.content === 'TEXT' ? (
          <div
            key={badgeType.id}
            className={`${styles.badge} ${className}`}
            style={{ color: badgeType.text_forecolor ? badgeType.text_forecolor : 'gray' }}
          >
            {badgeType.name}
          </div>
        ) : (
          <Image
            key={badgeType.id}
            src={badgeType.url}
            alt={badgeType.name}
            width={200}
            height={24}
            className={styles.imageStickerItem}
            style={{ borderRadius: '8px' }}
          />
        )
      )}
    </>
  );
};

export { ProductBadges };
